import React, { useEffect, useState } from "react";
import { FaEdit, FaMoneyBillWave, FaHandHoldingUsd } from "react-icons/fa";
import { BsX } from "react-icons/bs";
import Navbar from "../layouts/Navbar";
import Sidebar from "../layouts/Sidebar";
import Footer from "../layouts/Footer";
import axios from "axios";
import "./SalaryDeatails.css";

const SalaryDetails = () => {
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;
  const [data, setData] = useState([]);
  const [editItem, setEditItem] = useState(null);
  const [employqr, setEmployqr] = useState("");
  const [payPopup, setPayPopup] = useState(false);
  const [editForm, setEditForm] = useState({
    salary: "",
    salarydate: "",
    // salaryadvance: "",
  });
  const [payUpdateData,setPayUpdateData]=useState({
    PaidAmount:"",
    Screenshot:"",
    mode_of_pay:""
  })
  const [maxValue,setMaxValue] = useState(null);
  const [selectedUserid,setSelectedUserid] = useState(null);
  // Animation states
  const [animate, setAnimate] = useState(false); // controls slide animation
  const [visible, setVisible] = useState(false); // controls modal render

  // Open Pay Modal
  const openPayModal = () => {
    setVisible(true);
    setTimeout(() => setAnimate(true), 10); // trigger slide-in
  };

  // Close Pay Modal
  const closePayModal = () => {
    setAnimate(false); // trigger slide-down
    setTimeout(() => {
      setVisible(false); // unmount modal
      setPayPopup(false); // reset payPopup
    }, 300); // duration matches CSS transition

   setPayUpdateData({
    PaidAmount:"",
    Screenshot:"",
    mode_of_pay:""
  })

  };

  // Fetch salary data
  const getSalaryDetails = async () => {
    try {
      const response = await axios.get(`${api}/Admin/salarydetails`, {
        headers: { apikey },
      });
      setData(response.data.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSalaryDetails();
  }, []);

  // 🟩 Open Edit Modal
  const handleEditClick = (item) => {
    setEditItem(item);
    setEditForm({
      salary: item.salary || "",
      salarydate: item.salarydate || "",
      // salaryadvance: item.salaryadvance || "",
    });
  };

  // 🟨 Handle Edit Form Input
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  // 🟦 Save Changes (Update API)
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${api}/Admin/updatesalary/${editItem.userid}`,
        editForm,
        { headers: { apikey } }
      );
      alert(response.data.message || "Salary updated successfully!");
      setEditItem(null);
      getSalaryDetails(); // Refresh table
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || "Failed to update salary");
    }
  };

  // 🟥 Cancel Edit
  const handleCancelEdit = () => {
    setEditItem(null);
  };

  // 🟢 Handle Pay
  const handlePay = async (userId) => {
    try {
      if (!userId) return;
      const response = await axios.get(
        `${api}/salary/viewEmployeeQr/${userId}`,
        { headers: { apikey } }
      );
      // console.log(response.data);
      setEmployqr(response.data.data.salaryqr || "");
      setMaxValue(response.data.data.salarybalance || "")
      setSelectedUserid(response.data.data.userid || "")
      setPayPopup(true);
      openPayModal();
    } catch (err) {
      console.error(err.response?.data || err.message);
    }
  };

  const handlepayupdate = async () => {
  try {
    const formData = new FormData();
    formData.append("PaidAmount", payUpdateData.PaidAmount);
    formData.append("Screenshot", payUpdateData.Screenshot);
    formData.append("mode_of_pay", payUpdateData.mode_of_pay);
    formData.append("userid",selectedUserid );
    formData.append("paymentType",'salary')

    const response = await axios.post(
      `${api}/salary/slarypayment`,
      formData,
      {
        headers: {
          apikey,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    alert(response.data.message || "Payment updated successfully!");
    closePayModal();
    getSalaryDetails(); // refresh table
  } catch (error) {
    console.error(error.response?.data || error.message);
    alert(error.response?.data?.message || "Payment update failed");
  }
};


  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div style={{ padding: "5px" }}>
            <h4>Salary Details</h4>
          </div>

          <div style={{overflow:"auto"}}>
          <table
            className="table table-striped"
            style={{ backgroundColor: "white" }}
          >
            <thead>
              <tr>
                <th>S No</th>
                <th>Name</th>
                <th>Phone Number</th>
                <th>User ID</th>
                <th>Salary</th>
                <th>Salary Date</th>
                <th>Salary Balance</th>
                <th>Salary Advance</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.userid}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.phonenumber}</td>
                    <td>{item.userid}</td>
                    <td>₹{item.salary}</td>
                    <td>{item.salarydate}</td>
                    <td>{item.salarybalance}</td>
                    <td>{item.salaryadvance}</td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm me-2"
                        onClick={() => handleEditClick(item)}
                        title="Edit"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => handlePay(item.userid)}
                        className="btn btn-success btn-sm me-2"
                        title="Pay"
                      >
                        <FaMoneyBillWave />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center text-muted py-3">
                    No salary details found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          </div>

          {/* 🟢 Edit Modal */}
          {editItem && (
            <div className="modal-overlay">
              <div className="modal-content" style={{overflowY:"auto"}}>
                <h5>Edit Salary Details</h5>
                <form onSubmit={handleEditSubmit}>
                  <div className="form-group">
                    <label>Name:</label>
                    <input
                      type="text"
                      value={editItem.name}
                      readOnly
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number:</label>
                    <input
                      type="text"
                      value={editItem.phonenumber}
                      readOnly
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>User ID:</label>
                    <input
                      type="text"
                      value={editItem.userid}
                      readOnly
                      className="form-control"
                    />
                  </div>

                  {/* Editable Fields */}
                  <div className="form-group">
                    <label>Salary:</label>
                    <input
                      type="number"
                      name="salary"
                      value={editForm.salary}
                      onChange={handleEditChange}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Salary Date:</label>
                    <input
                      type="date"
                      name="salarydate"
                      value={editForm.salarydate}
                      onChange={handleEditChange}
                      className="form-control"
                      required
                    />
                  </div>

                  <div className="modal-actions">
                    <button type="submit" className="btn btn-primary me-2">
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={handleCancelEdit}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* 🟢 Pay Modal with slide-in/out */}
{visible && payPopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: animate ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10000,
      transition: "background 0.5s ease",
    }}
  >
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "8px",
        width: "400px",
        maxWidth: "90%",
        transform: animate ? "translateY(0)" : "translateY(200%)",
        transition: "transform 0.5s ease",
        boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
        height:'95vh',
          overflowY: "scroll",
    scrollbarWidth: "none", // ✅ Firefox
    msOverflowStyle: "none", // ✅ IE/Edge
      }}
        className="hide-scrollbar"
    >
      {/* Close Button */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <BsX
          style={{
            cursor: "pointer",
            fontSize: "20px",
            border: "1px solid red",
            color: "red",
          }}
          onClick={closePayModal}
        />
      </div>

      {/* Modal Form */}
    <form
  className="forms-sample"
  onSubmit={(e) => {
    e.preventDefault();       // Prevent page reload
    handlepayupdate();        // Call your submit handler
  }}
>
  <div className="form-group">
    <label htmlFor="salaryQR">Employee QR</label>
    <img
      src={`${api}/uploads/salaryqr/${employqr}`}
      alt="Employee QR"
      id="salaryQR"
      style={{ width: "100%", height: "300px", marginTop: "5px" }}
    />
  </div>

  <div className="form-group">
     <label htmlFor="paidAmount">Paid Amount (Max: ₹{maxValue})</label>
   <input
  type="text"
  className="form-control"
  id="paidAmount"
  name="PaidAmount"
  placeholder="Enter paid amount"
  value={payUpdateData.PaidAmount}
  onChange={(e) => {
    const value = e.target.value;
    // Only digits and less than or equal to maxValue
    if (/^\d*$/.test(value) && Number(value) <= maxValue) {
      setPayUpdateData({ ...payUpdateData, PaidAmount: value });
    }
  }}
  required
/>
  </div>


 <div className="form-group">
  <label htmlFor="modeOfPay">Mode of Payment</label>
  <select
    name="mode_of_pay"
    id="modeOfPay"
    className="form-control"
    style={{ padding: "0.875rem 1.375rem" }}
    value={payUpdateData.mode_of_pay}
    onChange={(e) => setPayUpdateData({ ...payUpdateData, mode_of_pay: e.target.value })}
  >
    <option value="">Select mode of payment</option>
    <option value="upi">UPI</option>
    <option value="cash">Cash</option>
  </select>
</div>


  <div className="form-group">
    <label htmlFor="screenshot">Screenshot</label>
    <input
      type="file"
      className="form-control"
      id="screenshot"
      name="Screenshot"
      onChange={(e) =>
        setPayUpdateData({ ...payUpdateData, Screenshot: e.target.files[0] })
      }
      required
    />
  </div>
  

  <button type="submit" className="btn btn-primary me-2">
    Submit
  </button>
  <button type="button" className="btn btn-light" onClick={closePayModal}>
    Cancel
  </button>
</form>

    </div>
  </div>
)}


        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SalaryDetails;
